/*******************************************************
 * ROUTES SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("services")


/**
 * Offers functions to access...routes (import / deletion / retrieval / ...)
 */
	.factory("RouteService", ["$resource", "$http", "SharedProperties", "ENV", "CONSTANTS", function ($resource, $http, SharedProperties, ENV, CONSTANTS) {
		return {

			/**
             * Fetch all routes (not imported yet)
             * @returns {*}
             */
			getBareRoutes: function () {
				return $resource(ENV.API_URL + "/brut/routesImportInfo",
					{
						token: SharedProperties.getApiToken(),
						companyId: SharedProperties.getAttribute(CONSTANTS.ATT_CURRENT_COMPANY)
					}).query();
			},

			/**
             * Delet a route gievn its ID
             * Note : two types of routes, with two different URLS, and two state of routes (imported / not imported).
             * Optional url parameter dev=true make a fake call and do not delete route.
             * @param routeId
             * @param routeState
             * @param routeType
             * @returns {*}
             */
			deleteRoute: function (routeId, routeState, routeType) {
				return $resource(ENV.API_URL + "/:state/:type/:id",
					{
						token: SharedProperties.getApiToken(),
						id: routeId,
						state: routeState,
						type: routeType
					});
			},

			/**
             * Get details for a particular imported route, given its ID
             * @param id
             * @param routeType route (i.e. bare route) or imported
             * @returns {*}
             */
			getRouteDetails: function (id, routeType) {
				return $http.get(ENV.API_URL + "/analyse/" + (routeType != null ? routeType : "route") + "/" + id);
			},

			/**
             * *
             * Post selected routes to server so it can be analyzed.
             * Once imported, routes, aren't 'vrut' anymore and can be retrieved using the 'analyzed' service
             * @param routeIds
             * @returns {*|HttpPromise}
             */
			importRoutes: function (routeIds) {
				return $http.post(ENV.API_URL + "/brut/route/import", routeIds);
			},

			/**
             * Fetch all imported routes.
             * @param routeType route or imported
             * @returns {*}
             */
			getImportedRoutes: function (routeType) {
				return $resource(ENV.API_URL + "/analyse/:type/imported",
					{
						token: SharedProperties.getApiToken(),
						type: routeType,
						companyId: SharedProperties.getAttribute(CONSTANTS.ATT_CURRENT_COMPANY)
					}).query();
			},

			/**
             * Get route section details.
             * @param id
             * @returns {*}
             */
			getRouteSections: function (id) {
				return $resource(ENV.API_URL + "/analyse/route/:routeId/decoupage",
					{
						routeId: id,
						token: SharedProperties.getApiToken()
					}).query();

			},

			/**
             * Export CSV
             * @param route id
             */

			buildCsvExportUrl: function (id) {
				var url = ENV.API_URL + "/analyse/route/" + id + "/export?x-okina-token=" + SharedProperties.getApiToken();
				return url;
			},

			/**
             * get kml file of a particular route
             * @param routeId
             * @param routeType (route or deadrun)
             * @returns {url file}
             */
			buildKmlExportUrl: function (routeId, routeType) {
				return ENV.API_URL + "/analyse/" + routeType + "/" + routeId + "/kml?" +
                    "x-okina-token=" + SharedProperties.getApiToken();
			},

			/**
             * post new name of a route
             * @param name, id, routeType
             * @returns {id}
             */
			postNameRoute: function (nroute, id, routeType) {
				var xdata = $.param({
					"token": SharedProperties.getApiToken(),
					"name": nroute.name
				});
				return $http({
					url: ENV.API_URL + "/analyse/" + routeType + "/" + id,
					method: "POST",
					data: xdata,
					headers: {"Content-Type": "application/x-www-form-urlencoded"}
				});
			}

		};
	}
	])


;


